import { userPermissionsReducer } from './reducers';


export default {
  userPermissions: userPermissionsReducer
}
